import { render, staticRenderFns } from "./Computers.vue?vue&type=template&id=7b5a1446&"
import script from "./Computers.vue?vue&type=script&lang=js&"
export * from "./Computers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports